export const TextInputType = {
    TEXT: "text",
    FILE: "file",
    EMAIL: "email",
    PASSWORD: "password",
    NUMBER: "number",
    CHECKBOX: "checkbox",
    DATEPICKER: "datepicker",
    RADIO: 'radio',
}

export const NumberValueType = {
    INT: "INT",
    DECIMAL: "DECIMAL",
}


export const MaskInputType = {
    NUMBER: "NUMBER",

}
